import React from "react";
import "./home.css";

export default function Home() {
  return (
    <div className="home-container">

      {/* Premium Hero Section */}
      <section className="hero premium-hero">
        <div className="hero-overlay">
          <h1>Welcome to Crown Residences</h1>
          <p>Your community. Your comfort. Your home.</p>
        </div>
      </section>

      {/* Luxury Divider */}
      <div className="luxury-divider"></div>

      {/* Modern About Section */}
      <section className="about-section">
        <h2>About Crown Residences</h2>
        <p>
          Crown Residences is a premium gated community designed for modern living.
          With world‑class amenities, transparent association management, and a
          resident‑first approach, we ensure comfort, safety, and convenience for
          every family.
        </p>

        <p>
          Our digital portal provides seamless access to essential services,
          community updates, and support — making everyday living effortless.
        </p>
      </section>

    </div>
  );
}